<app-line-graph [data]="data"></app-line-graph>
